import React, { useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { useGetCompanyUsers } from "../../hooks/useCrm";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { InputField1 } from "../InputField1/InputField1";
import { useAddTargetUser } from "../../hooks/useManagement";
import { useEffect } from "react";
const initvalue = {
  sale_target_id: "",
  amount: "",
  person_id: "",
};
export const AddTargetUserModal = ({ show, handleClose, targetId }) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initvalue);
  const { data, isLoading, refetch } = useGetCompanyUsers();
  const { mutateAsync: addTargetUser } = useAddTargetUser();
  const handleAddTargetUser = async (datom) => {
    await addTargetUser(datom);
  };
  const users = data?.data?.ManagersAndColleagues;
  const usersOptions = users?.map((user) => {
    return {
      value: user.IdUser,
      label:
        (user.FirstName ? user.FirstName : "") +
        " " +
        (user.LastName ? user.LastName : ""),
    };
  });
  useEffect(() => {
    if (targetId) {
      setForm({ ...form, sale_target_id: targetId });
    }
  }, [targetId]);
  return (
    <BootstrapModal
      modaltitle="افزودن عضو تارگت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-lg-6 col-12">
          <SimpleSelect1
            res={usersOptions}
            onChange={(e) => setForm({ ...form, person_id: e.value })}
            label="لیست اعضا"
          />
        </div>
        <div className="col-lg-6 col-12">
          <InputField1
            placeholder=" مقدار تارگت را وارد کنید"
            label="مقدار تارگت"
            onChange={(e) => setForm({ ...form, amount: e.target.value })}
          />
        </div>
        <div className="col-6 mt-3">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleAddTargetUser(form);
              handleClose();
            }}
          >
            ثبت
          </Button>
        </div>
        <div className="col-6 mt-3">
          <Button bgColor="#f1416c" onclick={handleClose} color="#fff">
            انصراف
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
